import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionWrapper from './SectionWrapper';
import ProductPreview from '../DisputeDetails.tsx/atoms/ProductPreview';
import InfoText from '../atoms/InfoText';
import { useGetDisputedProductsQuery } from '../../store/services/disputeService';
import { useParams } from 'react-router-dom';

export default function DisputedProducts() {
  const { t } = useTranslation();

  const params = useParams();

  const { data: disputedProducts } = useGetDisputedProductsQuery({
    disputeId: params?.disputeId,
  });

  const isOther = disputedProducts?.payload?.some(
    (p) => p.id === '00000000-0000-0000-0000-000000000000'
  );

  return (
    <SectionWrapper
      title={t('components.disputeFeature.disputedProducts')}
      subTitle={t('components.disputeFeature.displayDisputedProducts')}
    >
      <div>
        {isOther ? (
          <InfoText
            text={t('home.others')}
            className="!text-light-text-primary dark:!text-dark-text-primary"
          />
        ) : (
          disputedProducts?.payload?.map((p) => (
            <div
              key={p.id}
              className="border-b py-6 first:pt-0 last:pb-0 last:border-none dark:border-b-dark-text-placeholder"
            >
              <ProductPreview
                product={p}
                confirmationActions={
                  <div className="flex flex-col">
                    <InfoText
                      text={p?.quantity?.toString()}
                      className="!text-light-alert !font-semibold"
                    />
                    <InfoText
                      text={t('quantity')}
                      className="!text-light-alert"
                    />
                  </div>
                }
              />
            </div>
          ))
        )}
      </div>
    </SectionWrapper>
  );
}
